module.exports = __webpack_public_path__ + "img/deal.31a8946c.png";